import React from "react";
import { graphql } from "gatsby";
import { RichText } from "../../utils/richText";
import { motion } from "framer-motion";
import { FADE_UP, useInView } from "../animationUtils";
import ArrowSvg from "../arrowSvg";
import linkResolver from "../../utils/linkResolver";

export const fragments = graphql`
  fragment Page_NichePromoCta on PrismicPageDataBodyNichePromoCta {
    primary {
      image {
        url
      }
      title1 {
        text
      }
      body1 {
        richText
      }
      cta_url {
        url
        target
      }
      cta_label,
      eyebrow
    }
  }
  fragment FocusArea_NichePromoCta on PrismicFocusAreaDataBodyNichePromoCta {
    primary {
      image {
        url
      }
      title1 {
        text
      }
      body1 {
        richText
      }
      cta_url {
        url
        target
      }
      cta_label,
      eyebrow
    }
  }
  fragment Project_NichePromoCta on PrismicProjectDataBodyNichePromoCta {
    primary {
      image {
        url
      }
      title1 {
        text
      }
      body1 {
        richText
      }
      cta_url {
        url
        target
      }
      cta_label,
      eyebrow
    }
  }
  fragment Homepage_NichePromoCta on PrismicHomepageDataBodyNichePromoCta {
    primary {
      image {
        url
      }
      title1 {
        text
      }
      body1 {
        richText
      }
      cta_url {
        url
        target
      }
      cta_label,
      eyebrow
    }
  }
`;

function NichePromoCta({ data }) {
  const [refImage, inViewImage] = useInView();
  return (
    <div className="niche-promo-cta">
      <motion.div
        ref={refImage}
        {...FADE_UP}
        animate={inViewImage ? "start" : ""}
        className="niche-promo-cta__container"
      >
        {
          data?.primary?.image?.url && (
            <img src={data?.primary?.image?.url} alt={data?.primary?.title1?.text} className="niche-promo-cta__image" />
          )
        }

        <div className="niche-promo-cta__content">

          {
            data?.primary?.eyebrow && (
              <p className="niche-promo-cta__eyebrow">{data?.primary?.eyebrow}</p>
            )
          }
          {
            data?.primary?.title1?.text && (
              <h3 className="niche-promo-cta__title">{data?.primary?.title1?.text}</h3>
            )
          }

          {
            data?.primary?.body1?.richText && (
              <div className="niche-promo-cta__body">
                { RichText(data?.primary?.body1?.richText) }
              </div>
            )
          }

          {
          data?.primary?.cta_url?.url && data?.primary?.cta_label &&(
            <a href={linkResolver(data?.primary?.cta_url)} target={data?.primary?.cta_url?.target} className="niche-promo-cta__button hidden-mobile">
              {data?.primary?.cta_label}
              <ArrowSvg />
            </a>
          )
        }

        </div>
        {
          data?.primary?.cta_url?.url && data?.primary?.cta_label &&(
            <a href={linkResolver(data?.primary?.cta_url)} target={data?.primary?.cta_url?.target} className="niche-promo-cta__button hidden-tablet">
              {data?.primary?.cta_label}
              <ArrowSvg />
            </a>
          )
        }

      </motion.div>

    </div>
  );
}

export default NichePromoCta;
